import ExpandButton from 'components/molecules/expand-button';
import classNames from 'classnames';

import ClinicColumn from '../clinicDefaultView';
import s from './styles.module.scss';

import type { Clinic } from 'infrastructure/classes/clinic';

interface IProps {
  isExpanded?: boolean;
  onExpand?: () => void;
  clinic: Clinic;
  className?: string;
}
export default function ClinicParentView({
  clinic,
  isExpanded,
  className,
  onExpand,
}: IProps) {
  const isParent = !!clinic.childClinicsGuid.length;
  const isChild =
    Boolean(clinic?.parentClinicName) || Boolean(clinic?.parentClinicGuid);
  const isSingle = !isParent && !isChild;
  return (
    <div className={classNames(s['clinic-wrapper'], className)}>
      <div className={s['content-wrapper']}>
        {!isSingle && isExpanded && <div className={s['table-row']} />}
        {isParent && onExpand && isExpanded !== undefined && (
          <ExpandButton
            expanded={isExpanded}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              onExpand();
            }}
          />
        )}
        <ClinicColumn data={clinic} />
      </div>
    </div>
  );
}
